import { createBrowserHistory } from 'history';

import { basename } from './utils/constants';

export default createBrowserHistory({ basename });
